var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-765.000000, -33.000000)",
    fill: "#54575A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(765.000000, 33.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.578125,45.553125 L35.915625,33.890625 C39.046875,30.290625 40.940625,25.603125 40.940625,20.465625 C40.940625,9.178125 31.753125,0 20.475,0 C9.178125,0 0.009375,9.1875 0.009375,20.465625 C0.009375,31.74375 9.196875,40.93125 20.475,40.93125 C25.603125,40.93125 30.3,39.0375 33.9,35.90625 L45.5625,47.56875 C45.84375,47.85 46.209375,47.990625 46.575,47.990625 C46.940625,47.990625 47.30625,47.85 47.5875,47.56875 C48.13125,47.025 48.13125,46.10625 47.578125,45.553125 Z M2.86875,20.465625 C2.86875,10.7625 10.7625,2.86875 20.465625,2.86875 C30.16875,2.86875 38.0625,10.7625 38.0625,20.465625 C38.0625,30.16875 30.178125,38.071875 20.465625,38.071875 C10.7625,38.071875 2.86875,30.16875 2.86875,20.465625 Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9c6640c89913417c9794b0dc242fb532.svg";
export { ForwardRef as ReactComponent };